import React, { useEffect, useState } from "react"
import * as Yup from "yup"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Form,
  Input,
  FormFeedback,
  Button,
} from "reactstrap"

import { useFormik } from "formik"
import { Link, useNavigate, useParams } from "react-router-dom"
import leftArrow from "../../assets/images/icons/left-arrow.svg"
import file from "../../assets/images/icons/file-type.svg"
import check from "../../assets/images/icons/right-check.svg"

import CounterFundRequestModal from "pages/InvestorPages/ICDInvestments/counterFundRequestModal"
import {
  useIcdApproveOfferMutation,
  useIcdRejectOfferMutation,
  useLazyGetIcdDetailsQuery,
} from "store/api/icds/icds.api"
import { interestFrequency, repaymentSchedule } from "helpers/utils"
import {
  formatAmount,
  getDateOfRepayment,
  getFundRequirementDate,
  getIcdRequestStatus,
  getIcdsStatus,
} from "helpers/common"
import ApproveConfirmationModal from "./confirm/approveConfirmation"
import RejectConfirmationModal from "./confirm/rejectConfirmation"
import AlertAccessModal from "modals/alertAccessModal"
import { useSelector } from "react-redux"
import LoaderComponent from "components/loader"
import { usePermission } from "hooks/usePermission"
import { PERMISSIONS } from "helpers/roles"

const ViewICD = () => {
  //meta title
  document.title = "ICD Request | Prachay"

  const [open, setOpen] = useState(false)
  const { id } = useParams()
  const navigate = useNavigate()
  const [icdData, setIcdData] = useState()
  const { userType } = useSelector((state) => state.user)

  const [isToast, setIsToast] = useState(false)
  const [actionType, setActionType] = useState() //APPROVE,REJECT
  const { hasPermission } = usePermission()

  const [getDetails, { isFetching }] = useLazyGetIcdDetailsQuery()
  const [onApprove, { isLoading: isApproving }] = useIcdApproveOfferMutation()
  const [onReject, { isLoading: isRejecting }] = useIcdRejectOfferMutation()
  const [openAlertModal, setOpenAlertModal] = useState(false)

  useEffect(() => {
    if (id) {
      onGetDetails()
    }
  }, [id])

  const onGetDetails = async () => {
    try {
      const { data } = await getDetails({ id }).unwrap()
      setIcdData(data)
    } catch (error) {
      if (error.status === 404) {
        navigate("/icd")
      }
    }
  }

  const horizontalformik = useFormik({
    initialValues: {
      module: "",
      key: "",
      label: "",
    },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        {isFetching ? (
          <LoaderComponent />
        ) : (
          <Container fluid>
            <Row>
              <Col xl={12} className="mt-4">
                <Card>
                  <CardBody className="pt-4">
                    <div className="d-flex align-items-center mb-4 justify-content-between ">
                      <CardTitle className="heading-badge">
                        <span> ICD Request ( {icdData?.unique_code} )</span>
                      </CardTitle>
                      {!isFetching && icdData && (
                        <>
                          {(() => {
                            const icdsReq = icdData?.icdsRequest
                            return (
                              <div className="code-status">
                                {getIcdRequestStatus(icdsReq.status)}
                              </div>
                            )
                          })()}
                        </>
                      )}
                    </div>
                    <Form onSubmit={horizontalformik.handleSubmit}>
                      <Row className="mb-2">
                        <Col xl={6}>
                          <Label
                            htmlFor="horizontal-firstname-Input"
                            className="col-form-label"
                          >
                            Investor Name
                          </Label>
                          <Input
                            disabled
                            name="Name "
                            type="text"
                            className="form-control"
                            id="horizontal-email-id "
                            placeholder="Investor Name"
                            value={icdData?.investor?.name}
                          />
                        </Col>
                        <Col xl={6}>
                          <Label
                            htmlFor="horizontal-firstname-Input"
                            className="col-form-label"
                          >
                            Email Address
                          </Label>
                          <Input
                            disabled
                            name="Name "
                            type="text"
                            className="form-control"
                            id="horizontal-email-id "
                            placeholder="Email Address"
                            value={icdData?.investor?.email}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col xl={6}>
                          <Label
                            htmlFor="horizontal-firstname-Input"
                            className="col-form-label"
                          >
                            Mobile
                          </Label>
                          <Input
                            disabled
                            name="Name "
                            type="text"
                            className="form-control"
                            id="horizontal-email-id "
                            placeholder="Phone No."
                            value={icdData?.investor?.phone}
                          />
                        </Col>
                        <Col xl={6}>
                          <Label
                            htmlFor="horizontal-firstname-Input"
                            className="col-form-label"
                          >
                            PAN
                          </Label>
                          <Input
                            disabled
                            name="Name "
                            type="text"
                            className="form-control"
                            id="horizontal-email-id "
                            placeholder="PAN"
                            value={icdData?.investor?.pan_no}
                          />
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>

                <Card>
                  <CardBody className="pt-4">
                    <CardTitle className="mb-4">ICD Details</CardTitle>
                    <Row className="mb-2">
                      <Col xl={12}>
                        <Row className="mb-2">
                          <Col xl={6}>
                            <Label className="col-form-label">
                              Investment Amount
                            </Label>
                            <Input
                              disabled
                              type="text"
                              className="form-control"
                              id="horizontal-firstname-Input"
                              placeholder="Investment Amount"
                              value={`₹ ${formatAmount(icdData?.amount)}`}
                            />
                          </Col>
                          <Col xl={6}>
                            <Label className="col-form-label">
                              Date of Repayment
                            </Label>
                            <Input
                              disabled
                              type="text"
                              className="form-control"
                              id="horizontal-email-id "
                              placeholder="Date of Repayment"
                              value={getDateOfRepayment(
                                icdData?.repayment_date
                              )}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col xl={6}>
                            <Label className="col-form-label">
                              Tenure(in days)
                            </Label>
                            <Input
                              disabled
                              type="text"
                              className="form-control"
                              placeholder="Tenure"
                              value={icdData?.tenure}
                            />
                          </Col>
                          <Col xl={6}>
                            <Label className="col-form-label">
                              Interest Rate (%)
                            </Label>
                            <Input
                              disabled
                              type="text"
                              className="form-control"
                              placeholder="Interest Rate"
                              value={icdData?.interest_rate}
                            />
                          </Col>

                          <Col xl={6}>
                            <Label className="col-form-label">
                              Interest Payment Frequency
                            </Label>
                            <Input
                              disabled
                              type="text"
                              className="form-control"
                              placeholder="Interest Rate"
                              value={
                                icdData &&
                                interestFrequency.find(
                                  (item) =>
                                    item.key === icdData?.interest_frequency
                                ).label
                              }
                            />
                          </Col>

                          <Col xl={6}>
                            <Label className="col-form-label">
                              Fund Availability Date
                            </Label>
                            <Input
                              disabled
                              type="text"
                              className="form-control"
                              id="horizontal-email-id "
                              placeholder="Fund Availability Date"
                              value={getFundRequirementDate(
                                icdData?.fund_requirement_date
                              )}
                            />
                          </Col>
                          <Col xl={6}>
                            <Label className="col-form-label">
                              Lock-in (in days)
                            </Label>
                            <Input
                              name="lockin_period"
                              type="number"
                              disabled
                              className="form-control"
                              id="lockin_period"
                              placeholder="Days"
                              value={icdData?.lockin_period}
                            />
                          </Col>
                          <Col xl={6}>
                            <Label className="col-form-label">
                              Notice Period (in days)
                            </Label>
                            <Input
                              name="lockin_period"
                              type="number"
                              disabled
                              className="form-control"
                              id="lockin_period"
                              placeholder="Days"
                              value={icdData?.notice_period}
                            />
                          </Col>
                          <Col xl={6}>
                            <Label className="col-form-label">
                              Repayment Schedule
                            </Label>
                            <Input
                              disabled
                              type="text"
                              className="form-control"
                              id="horizontal-email-id "
                              placeholder="Fund Requirement Date"
                              value={
                                icdData &&
                                repaymentSchedule.find(
                                  (item) =>
                                    item.key === icdData?.repayment_schedule
                                ).label
                              }
                            />
                          </Col>
                          {icdData?.repayment_schedule === "MULTIPLE" && (
                            <Col xl={6}>
                              <Label className="col-form-label">
                                No. Of Installments
                              </Label>
                              <Input
                                name="repayment_terms"
                                type="number"
                                disabled
                                className="form-control"
                                id="repayment_terms"
                                placeholder="Total Installments"
                                value={icdData?.repayment_terms}
                              />
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            {icdData?.icdsRequest?.countered && (
              <Card>
                <CardBody className="pt-0">
                  <Row className="mb-2">
                    <CardTitle className="my-4">
                      Counter offer by the admin
                    </CardTitle>
                  </Row>

                  <Row className="mb-2">
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Investment Amount
                      </Label>
                      <Input
                        disabled
                        type="text"
                        className="form-control"
                        id="horizontal-firstname-Input"
                        placeholder="Investment Amount"
                        value={`₹ ${formatAmount(icdData?.icdsRequest?.amount)}`}
                      />
                    </Col>

                    <Col xl={6}>
                      <Label className="col-form-label">
                        Date of Repayment
                      </Label>
                      <Input
                        disabled
                        type="text"
                        className="form-control"
                        id="horizontal-email-id "
                        placeholder="Date of Repayment"
                        value={getDateOfRepayment(
                          icdData?.icdsRequest?.repayment_date
                        )}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col xl={6}>
                      <Label className="col-form-label">Tenure(in days)</Label>
                      <Input
                        disabled
                        type="text"
                        className="form-control"
                        placeholder="Tenure"
                        value={icdData?.icdsRequest?.tenure}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Interest Rate (%)
                      </Label>
                      <Input
                        disabled
                        type="text"
                        className="form-control"
                        placeholder="Interest Rate"
                        value={icdData?.icdsRequest?.interest_rate}
                      />
                    </Col>

                    <Col xl={6}>
                      <Label className="col-form-label">
                        Interest Payment Frequency
                      </Label>
                      <Input
                        disabled
                        type="text"
                        className="form-control"
                        placeholder="Interest Rate"
                        value={
                          icdData?.icdsRequest &&
                          interestFrequency.find(
                            (item) =>
                              item.key ===
                              icdData?.icdsRequest?.interest_frequency
                          ).label
                        }
                      />
                    </Col>

                    <Col xl={6}>
                      <Label className="col-form-label">
                        Fund Requirement Date
                      </Label>
                      <Input
                        disabled
                        type="text"
                        className="form-control"
                        id="horizontal-email-id "
                        placeholder="Fund Requirement Date"
                        value={
                          icdData?.icdsRequest &&
                          getFundRequirementDate(
                            icdData?.icdsRequest.fund_requirement_date
                          )
                        }
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Lock-in (in days)
                      </Label>
                      <Input
                        name="lockin_period"
                        type="number"
                        disabled
                        className="form-control"
                        id="lockin_period"
                        placeholder="Days"
                        value={icdData?.icdsRequest?.lockin_period}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Notice Period (in days)
                      </Label>
                      <Input
                        name="lockin_period"
                        type="number"
                        disabled
                        className="form-control"
                        id="lockin_period"
                        placeholder="Days"
                        value={icdData?.icdsRequest?.notice_period}
                      />
                    </Col>
                    <Col xl={6}>
                      <Label className="col-form-label">
                        Repayment Schedule
                      </Label>
                      <Input
                        disabled
                        type="text"
                        className="form-control"
                        id="horizontal-email-id "
                        placeholder="Fund Requirement Date"
                        value={
                          icdData?.icdsRequest &&
                          repaymentSchedule.find(
                            (item) =>
                              item.key ===
                              icdData?.icdsRequest?.repayment_schedule
                          ).label
                        }
                      />
                    </Col>
                    {icdData?.icdsRequest?.repayment_schedule ===
                      "MULTIPLE" && (
                        <Col xl={6}>
                          <Label className="col-form-label">
                            No. Of Installments
                          </Label>
                          <Input
                            name="repayment_terms"
                            type="number"
                            disabled
                            className="form-control"
                            id="repayment_terms"
                            placeholder="Total Installments"
                            value={icdData?.icdsRequest.repayment_terms}
                          />
                        </Col>
                      )}
                  </Row>
                  {icdData?.icdsRequest?.comments && (
                    <Row className="mb-2">
                      <Col xl={12}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Comments / Notes
                        </Label>
                        <Input
                          disabled
                          name="Name "
                          type="textarea"
                          className="form-control textarea"
                          id="horizontal-email-id "
                          placeholder="Comment"
                          value={icdData?.icdsRequest?.comments}
                        />
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            )}
            {["OPEN"].includes(icdData?.icdsRequest?.status) &&
              hasPermission(PERMISSIONS.ICD_UPDATE) && (
                <>
                  <Row>
                    <Col xl={12}>
                      <div className="buttons">
                        <Button
                          onClick={() => {
                            if (
                              userType === "ADMIN" &&
                              icdData?.investor?.entity_type === "INDIVIDUAL"
                            ) {
                              setOpenAlertModal(true)
                            } else {
                              setOpen(true)
                            }
                          }}
                          className="counteroffer"
                        >
                          Negotiate
                        </Button>
                        <Button
                          className="reject"
                          onClick={() => {
                            setIsToast(true)
                            setActionType("REJECT")
                          }}
                        >
                          Reject
                        </Button>
                        <Button
                          className="approve"
                          onClick={() => {
                            if (
                              userType === "ADMIN" &&
                              icdData?.investor?.entity_type === "INDIVIDUAL"
                            ) {
                              setOpenAlertModal(true)
                            } else {
                              setIsToast(true)
                              setActionType("APPROVE")
                            }
                          }}
                        >
                          Approve
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
          </Container>
        )}
      </div>
      <CounterFundRequestModal
        from="ADMIN"
        open={open}
        setOpen={setOpen}
        data={icdData}
        setCancelRequestOpen={() => { }}
        onSuccess={() => {
          onGetDetails()
          setOpen(false)
        }}
      />

      {icdData && isToast && actionType === "APPROVE" && (
        <ApproveConfirmationModal
          open={isToast}
          id={icdData.id}
          icdData={icdData}
          setOpen={setIsToast}
          isLoading={isApproving}
          onClose={() => {
            setIsToast(false)
            setActionType("")
          }}
          onApprove={onApprove}
          onSuccess={() => {
            onGetDetails()
            setIsToast(false)
          }}
        />
      )}

      {icdData && isToast && actionType === "REJECT" && (
        <RejectConfirmationModal
          open={isToast}
          id={icdData.id}
          setOpen={setIsToast}
          isLoading={isRejecting}
          onClose={() => {
            setIsToast(false)
            setActionType("")
          }}
          onReject={onReject}
          onSuccess={() => {
            onGetDetails()
            setIsToast(false)
          }}
        />
      )}
      {openAlertModal && (
        <AlertAccessModal
          open={openAlertModal}
          onClose={() => setOpenAlertModal(false)}
        />
      )}
    </React.Fragment>
  )
}

export default ViewICD
